import axios from "axios";
import { BUSINESS_API_BASE_URL } from "./endpoint.js";

export const createPaymentIntent = async (businessId,paymentIntentData) => {
  try {
    const response = await axios.post(`${BUSINESS_API_BASE_URL}/stripe/payment-intent/${businessId}`, paymentIntentData);
    return response.data;
  } catch (error) {
    console.error("Error creating payment intent:", error);
    throw error;
  }
};
